/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Anchor_SourceInputs */

const en_us2_body_assessment_anchor_source = /** @type {(inputs: Body_Assessment_Anchor_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the assessment that set this`)
};

const pt_br2_body_assessment_anchor_source = /** @type {(inputs: Body_Assessment_Anchor_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver a avaliação que definiu isto`)
};

const es_419_body_assessment_anchor_source = /** @type {(inputs: Body_Assessment_Anchor_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir la evaluación que la definió`)
};

const pt_pt2_body_assessment_anchor_source = /** @type {(inputs: Body_Assessment_Anchor_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver a avaliação que definiu isto`)
};

const fr_fr2_body_assessment_anchor_source = /** @type {(inputs: Body_Assessment_Anchor_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir l'évaluation qui l'a définie`)
};

const de_de2_body_assessment_anchor_source = /** @type {(inputs: Body_Assessment_Anchor_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messung öffnen, die das festgelegt hat`)
};

const it_it2_body_assessment_anchor_source = /** @type {(inputs: Body_Assessment_Anchor_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri la valutazione che l'ha impostata`)
};

/**
* | output |
* | --- |
* | "Open the assessment that set this" |
*
* @param {Body_Assessment_Anchor_SourceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_anchor_source = /** @type {((inputs?: Body_Assessment_Anchor_SourceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Anchor_SourceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_anchor_source(inputs)
	if (locale === "es-419") return es_419_body_assessment_anchor_source(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_anchor_source(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_anchor_source(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_anchor_source(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_anchor_source(inputs)
	return en_us2_body_assessment_anchor_source(inputs)
});
export { body_assessment_anchor_source as "body-assessment.anchor_source" }